import { useMutation } from "@tanstack/react-query";

import { n8nInstance } from "@shared/services";

const N8N_ENV = "prd";

const URLS = {
  generateReport: `${N8N_ENV}/payfac/report`,
  generateBalanceReport: `${N8N_ENV}/v1/company/balance-report`,
};

const api = n8nInstance({
  enableBearerToken: true,
  enableXTokenApi: true,
});

type GenerateReportPayload = {
  idCompany: number;
  type: string;
  startDate: string;
  endDate: string;
  email: string;
  idSeller?: number;
};

type GenerateBalanceReportPayload = {
  idCompany: number;
  transferDate: string;
  email: string;
};

const generateReport = async (params: GenerateReportPayload) => {
  const { data } = await api.get(URLS.generateReport, { params });
  return data;
};

const generateBalanceReport = async (params: GenerateBalanceReportPayload) => {
  const { data } = await api.get(URLS.generateBalanceReport, {
    params: { ...params, idCompany: String(params.idCompany) },
  });
  return data;
};

export const useGenerateBalanceReport = () =>
  useMutation({ mutationFn: generateBalanceReport });

export const useGenerateReport = () =>
  useMutation({ mutationFn: generateReport });
